import { useState } from "react";
import { Menu, X, CalendarCheck } from "lucide-react";
import { BOOKSY_URL, NAV_LINKS } from "@/data/content";
import { Logo } from "@/components/Logo";

export const Navbar = () => {
    const [open, setOpen] = useState(false);

    return (
        <header
            data-testid="navbar"
            className="fixed inset-x-0 top-0 z-50 border-b border-white/10 bg-ink/70 backdrop-blur-xl"
        >
            <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6 md:h-[72px] lg:px-8">
                <a href="#inicio" data-testid="navbar-logo-link" aria-label="Ir al inicio">
                    <Logo testId="navbar-logo" className="h-11 w-auto md:h-14" />
                </a>

                <nav className="hidden items-center gap-8 md:flex" data-testid="nav-desktop-menu">
                    {NAV_LINKS.map((link) => (
                        <a
                            key={link.href}
                            href={link.href}
                            data-testid={link.testId}
                            className="nav-link text-sm font-semibold tracking-wide text-gray-300 transition-colors duration-200 hover:text-gold"
                        >
                            {link.label}
                        </a>
                    ))}
                    <a
                        href={BOOKSY_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="nav-booking-btn"
                        className="inline-flex items-center gap-2 rounded-sm bg-gold px-5 py-2.5 text-sm font-bold text-ink shadow-lg shadow-black/30 transition-[background-color,transform] duration-200 hover:-translate-y-0.5 hover:bg-[#a88a1e]"
                    >
                        <CalendarCheck className="h-4 w-4" />
                        Reservar
                    </a>
                </nav>

                <button
                    type="button"
                    data-testid="mobile-menu-btn"
                    aria-label={open ? "Cerrar menú" : "Abrir menú"}
                    onClick={() => setOpen((v) => !v)}
                    className="inline-flex items-center justify-center rounded-sm border border-white/15 p-2 text-gray-200 transition-colors duration-200 hover:text-white md:hidden"
                >
                    {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
                </button>
            </div>

            {open && (
                <nav
                    data-testid="nav-mobile-menu"
                    className="border-t border-white/10 bg-ink/95 px-4 pb-6 pt-4 backdrop-blur-xl md:hidden"
                >
                    <div className="flex flex-col gap-1">
                        {NAV_LINKS.map((link) => (
                            <a
                                key={link.href}
                                href={link.href}
                                data-testid={`mobile-${link.testId}`}
                                onClick={() => setOpen(false)}
                                className="rounded-sm px-3 py-3 text-base font-semibold text-gray-200 transition-colors duration-200 hover:bg-white/5 hover:text-gold"
                            >
                                {link.label}
                            </a>
                        ))}
                        <a
                            href={BOOKSY_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="mobile-nav-booking-btn"
                            className="mt-3 inline-flex items-center justify-center gap-2 rounded-sm bg-gold px-5 py-3 text-base font-bold text-ink transition-colors duration-200 hover:bg-[#a88a1e]"
                        >
                            <CalendarCheck className="h-5 w-5" />
                            Reservar Cita
                        </a>
                    </div>
                </nav>
            )}
        </header>
    );
};
